import { useComputedColorScheme } from "@mantine/core";
import type { JsonServiceClient } from "@servicestack/client";
import { useMemo, type FC, type PropsWithChildren } from "react";
import DefaultClient from "src/api/client";
import ServiceStackClientContext from "src/contexts/api/ServiceStackClientContext";

interface IServiceStackClientProviderProps extends PropsWithChildren {
    baseUrl?: string;
    basePath?: string;
}

const ServiceStackClientProvider: FC<IServiceStackClientProviderProps> = ({
    children,
    baseUrl,
    basePath,
}) => {
    const colorScheme = useComputedColorScheme();

    const client = useMemo(() => {
        return DefaultClient(baseUrl, basePath, colorScheme);
    }, [baseUrl, basePath, colorScheme]);

    return (
        <ServiceStackClientContext.Provider value={client}>
            {children}
        </ServiceStackClientContext.Provider>
    );
};

export default ServiceStackClientProvider;
